import styled from 'styled-components';
import { StyledDiv } from '../../Theme/CommonStyled';

export const StyledCode = styled(StyledDiv)<{ codeIsCopied: boolean }>`
  transition: 0.3s;
  ${({ codeIsCopied }): string =>
    codeIsCopied ? `transform: scale(0);` : `transform: scale(1);`}
`;
